import { IConfig, TApplePaySession, TInitParams } from '../types';
import { SERVER_URL } from '../constants';

export const getParameters = async (data: TInitParams): Promise<IConfig> => {
  const res = await fetch(`${SERVER_URL}/PayPage/Init`, {
    method: 'POST',
    mode: 'cors',
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  });

  const result = await res.json();

  if (res.status !== 200 && res.status !== 400) {
    throw new Error(result.message || res.statusText);
  }

  return result;
};

export const validateMerchant = async (data: TApplePaySession): Promise<string> => {
  const res = await fetch(`${SERVER_URL}/PayPage/ValidateMerchant`, {
    method: 'POST',
    mode: 'cors',
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  });

  const result = await res.json();

  return result;
};
